
{
  "fr": {
    "configuratorCustomizationSummary": {
      "informations": {
        "title": "Votre produit",
        "label": {
          "model": "Format",
          "quantity": "Quantité",
          "theme": "Votre visuel",
          "textCustomization": "Personnalisation texte {0}"
        }
      },
      "product": {
        "title": "Visuel et personnalisation",
        "label": {
          "expressMode": "Réalisation express",
          "price": "Tarif TTC",
          "price_without_vat": "Tarif HT"
        },
        "value": {
          "expressMode": {
            "yes": "Oui",
            "no": "Non"
          },
          "price": "{unitPrice}/gobelet soit {price}",
          "totalPrice": "{price} € TTC",
          "unitPrice": "{price} € TTC/gobelet"
        },
        "customizationType": {
          "text": "Texte",
          "image": "Image"
        }
      }
    }
  }
}

